module.exports = { "default": require("core-js/library/fn/string/trim"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ../~/babel-runtime/core-js/string/trim.js
// module id = 554
// module chunks = 1